var $22a5f0623ea73e4f$exports = {};
$22a5f0623ea73e4f$exports = {
  "dateRange": args => `${args.startDate} ~ ${args.endDate}`,
  "dateSelected": args => `${args.date} \u{C120}\u{D0DD}\u{B428}`,
  "finishRangeSelectionPrompt": `\u{B0A0}\u{C9DC} \u{BC94}\u{C704} \u{C120}\u{D0DD}\u{C744} \u{C644}\u{B8CC}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
  "maximumDate": `\u{B9C8}\u{C9C0}\u{B9C9}\u{C73C}\u{B85C} \u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C77C}\u{C790}`,
  "minimumDate": `\u{CC98}\u{C74C}\u{C73C}\u{B85C} \u{C0AC}\u{C6A9} \u{AC00}\u{B2A5}\u{D55C} \u{C77C}\u{C790}`,
  "next": `\u{B2E4}\u{C74C}`,
  "previous": `\u{C774}\u{C804}`,
  "selectedDateDescription": args => `\u{C120}\u{D0DD} \u{C77C}\u{C790}: ${args.date}`,
  "selectedRangeDescription": args => `\u{C120}\u{D0DD} \u{BC94}\u{C704}: ${args.dateRange}`,
  "startRangeSelectionPrompt": `\u{B0A0}\u{C9DC} \u{BC94}\u{C704} \u{C120}\u{D0DD}\u{C744} \u{C2DC}\u{C791}\u{D558}\u{B824}\u{BA74} \u{D074}\u{B9AD}\u{D558}\u{C2ED}\u{C2DC}\u{C624}.`,
  "todayDate": args => `\u{C624}\u{B298}, ${args.date}`,
  "todayDateSelected": args => `\u{C624}\u{B298}, ${args.date} \u{C120}\u{D0DD}\u{B428}`
};
export { $22a5f0623ea73e4f$exports as default };